import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridInputField from './GridInputField'
import { formatBodyField } from '../hooks/utils-functions'
import { useGetImpostazioniContattiQuery } from '../hooks/api-slice'
import { titlesImpostazioni } from '../settings/settings'
import { setImpostazioniContatti } from '../container/home'

const DialogImpostazioniContatti = ({ open, handleClose, triggerFunction }) => {
  const { data: contatti } = useGetImpostazioniContattiQuery()
  const impostazioniContatti = useSelector(
    state => state.home.impostazioniContatti,
  )
  const dispatch = useDispatch()

  useEffect(() => {
    if (open) dispatch(setImpostazioniContatti(contatti))
  }, [contatti, dispatch, open])

  const cDispatch = (field, value) =>
    dispatch(
      setImpostazioniContatti({
        ...impostazioniContatti,
        [field]: formatBodyField(value),
      }),
    )

  const MyGridInputField = (label, field) => (
    <GridInputField
      label={label}
      field={field}
      value={impostazioniContatti?.[field]}
      onChange={cDispatch}
      type='text'
      md={12}
    />
  )

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={triggerFunction}
      title={titlesImpostazioni.titleContatti}
      textConfirm='Salva'
    >
      Indirizzi mostrati in varie pagine della piattaforma per suggerire chi
      contattare.
      <br />
      <br />
      <Grid container alignItems='center' spacing={2} sx={{ width: '100%' }}>
        {MyGridInputField('Mail principale', 'MailPrincipale')}
        {MyGridInputField('Mail segreteria', 'MailSegreteria')}
        {MyGridInputField('Mail per iscrizioni', 'MailIscrizioni')}
        {MyGridInputField('Mail per spostamenti', 'MailSpostamenti')}
        {MyGridInputField('Mail per risultati', 'MailRisultati')}
      </Grid>
    </Dialog>
  )
}

export default DialogImpostazioniContatti
